import { getChildWidgetStyle, handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
const type = 'alert.voiceOptionsLayout';
const WidgetVoiceOptionsLayout = (props) => {
    const upSmScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    let rootSx = {};
    let childSx = { width: '100%' };
    if (upSmScreen && props.childProps && props.childProps.length === 2) {
        rootSx = { display: 'flex', gap: 2 };
        if (props.childProps[1].hidden) {
            childSx = { width: '50%' };
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: rootSx }, props.childProps &&
            props.childProps.map((childProp, index) => (React.createElement(Box, { key: childProp.id, sx: Object.assign({ pb: !upSmScreen && index === 0 ? 2 : 0 }, childSx), style: getChildWidgetStyle(childProp) }, childProp.hidden ? undefined : React.createElement(WidgetComponent, Object.assign({}, childProp))))))));
};
export const widgetVoiceOptionsLayout = {
    type,
    update: (props) => handleWidgetUpdate(props),
    childConfigs: (config) => config.children,
    component: WidgetVoiceOptionsLayout,
};
